import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import moment from 'moment';

import './styles.css';

const CountdownTimer = props => {
  const { text, expireDate } = props;

  const calculateTimeLeft = () => {
    const end = moment.utc(expireDate);
    const start = moment().utc();

    if (start.isSameOrAfter(end)) {
      return {};
    }

    const m = end.diff(start, 'months');
    const d = end.diff(start.clone().add(m, 'M'), 'days');
    const h = end.diff(
      start
        .clone()
        .add(m, 'M')
        .add(d, 'd'),
      'hours'
    );

    return {
      months: m,
      days: d,
      hours: h,
    };
  };

  const [timeOptions, setTimeOptions] = useState(calculateTimeLeft());

  useEffect(() => {
    let interval = null;

    if (!!Object.keys(timeOptions).length) {
      interval = setInterval(() => {
        setTimeOptions(calculateTimeLeft());
      }, 60000);
    } else {
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [timeOptions]);

  const timerComponents = useMemo(() => {
    const timerComponents = [];
    const keys = Object.keys(timeOptions);

    keys.forEach(interval => {
      if (timeOptions[interval]) {
        timerComponents.push(
          <span key={interval} className="countdown-timer__time">
            {timeOptions[interval]} {pluralize(interval, timeOptions[interval])}{' '}
          </span>
        );
      }
    });

    if (
      keys.length &&
      (!timeOptions.months && !timeOptions.days && !timeOptions.hours)
    ) {
      timerComponents.push(
        <span key="tmp" className="countdown-timer__time">
          less than an hour
        </span>
      );
    }

    return timerComponents;
  }, [timeOptions]);

  return (
    timerComponents.length > 0 && (
      <div className="countdown-timer">
        <h4 className="countdown-timer__heading">{text}</h4>
        <p className="countdown-timer__subheading">
          Expires in: {timerComponents}
        </p>
      </div>
    )
  );
};

CountdownTimer.propTypes = {
  text: PropTypes.string.isRequired,
  expireDate: (props, propName) => {
    const regex = RegExp(/^\d{4}-\d\d-\d\d(\s\d\d:\d\d:\d\d)?$/);
    return regex.test(props[propName])
      ? null
      : new Error(
          `${propName} format should be yyyy-MM-dd or yyyy-mm-dd hh:mm:ss`
        );
  },
};

export default CountdownTimer;
